import KeywordFilter from "components/filters/Filters/KeywordFilter";
import React from "react";

const Filters = () => {
  return <>
    <KeywordFilter
      label={RESX.GeneralLabels.Search}
      placeholder={RESX.GeneralLabels.Search}
      title={RESX.GeneralLabels.Search}
    />
  </>;
};

export default Filters;